/**
 * Haptics. Android and desktop Chrome have navigator.vibrate. iOS Safari has no
 * vibration API at all; from iOS 18 the only web-reachable haptic is the tick a
 * <input type="checkbox" switch> gives when toggled, so a hidden one is toggled
 * instead. Anything else is a silent no-op.
 */
let enabled = true;
let iosSwitch: HTMLInputElement | null = null;

export const setHaptics = (on: boolean): void => { enabled = on; };

function iosTick(): void {
  if (typeof document === 'undefined') return;
  if (!iosSwitch) {
    iosSwitch = document.createElement('input');
    iosSwitch.type = 'checkbox';
    iosSwitch.setAttribute('switch', '');
    iosSwitch.setAttribute('aria-hidden', 'true');
    iosSwitch.tabIndex = -1;
    iosSwitch.style.cssText = 'position:fixed;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.appendChild(iosSwitch);
  }
  try { iosSwitch.click(); } catch { /* ignore */ }
}

export function haptic(ms: number | number[] = 8): void {
  if (!enabled || typeof navigator === 'undefined') return;
  if (typeof navigator.vibrate === 'function') {
    try { navigator.vibrate(ms); } catch { /* unsupported */ }
    return;
  }
  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) iosTick();
}

/** a firmer tap for a completed step */
export const hapticDone = (): void => haptic([14, 40, 14]);

export const reducedMotion = (): boolean =>
  typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
